import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { HiChevronDown } from 'react-icons/hi'

interface FilterMenuProps {
  name: string
  activeCnt?: number
  children: JSX.Element[] | JSX.Element
}

export default function FilterMenu({ name, activeCnt = 0, children }: FilterMenuProps) {
  return (
    <Popover className="px-4 relative inline-block text-left">
      <Popover.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900 outline-brand-500 pl-1 -ml-1">
        <span>{name}</span>
        {activeCnt > 0 && (
          <span className="ml-1.5 rounded py-0.5 px-1.5 bg-brand-500 text-xs font-semibold text-white tabular-nums">
            {activeCnt}
          </span>
        )}
        <HiChevronDown
          className="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
      </Popover.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Popover.Panel className="origin-top-right absolute right-0 mt-2 bg-white rounded-md shadow-2xl p-4 ring-1 ring-black ring-opacity-5 focus:outline-none">
          {children}
        </Popover.Panel>
      </Transition>
    </Popover>
  )
}
